"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[6012],{

/***/ 40876:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _elephant_healthcare_mui_button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2550);
/* harmony import */ var _elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21534);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(948);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61800);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95061);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52018);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12850);
/* harmony import */ var _utils_text__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55806);
/* harmony import */ var _AncEncounterContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10080);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17234);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13875);









const AncEncouterResultField = ({
  field,
  status
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
  container: true
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
  item: true,
  xs: 8
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
  variant: "body2"
}, field))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
  item: true,
  xs: 4
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
  variant: "body2"
}, status)));
const AncEncounterCard = ({ encounter }) => {
  var _a, _b, _c;
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  const getLinkToExistingEncounter = (0,_AncEncounterContext__WEBPACK_IMPORTED_MODULE_3__/* .useLinkToExistingAntenatalCarePatient */ .IS)();
  const link = getLinkToExistingEncounter(encounter.id);
  const { createdBy, clinic } = encounter;
  const fields = Object.entries(encounter).reduce(
    (acc, [key, value]) => {
      if (!_constants__WEBPACK_IMPORTED_MODULE_4__/* .fieldFormatters */ .lR[key])
        return acc;
      const { label, section, format } = _constants__WEBPACK_IMPORTED_MODULE_4__/* .fieldFormatters */ .lR[key];
      acc[section] || (acc[section] = []);
      acc[section].push({ field: formatMessage(label), status: format(value) });
      return acc;
    },
    {}
  );
  const sections = Object.entries(fields);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Zb, {
    color: _elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__/* .CardColors.CONSULTATION */ .L3.CONSULTATION
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__/* .CardBody */ .eW, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__/* .CardSummary */ .Jy, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    display: "flex",
    justifyContent: "space-between"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__/* .CardSubtitle */ ._R, {
    color: _elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__/* .CardColors.CONSULTATION */ .L3.CONSULTATION
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    id: "patient.anc.history.card.subtitle",
    defaultMessage: "Consultation"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__/* .CardTitle */ .ll, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    id: "patient.anc.history.card.title",
    defaultMessage: "Visit #{num, number}: {date}",
    values: {
      num: (_a = encounter.visitNumber) != null ? _a : 1,
      date: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(
        new Date(encounter.createdAt),
        "dd MMM yyyy"
      )
    }
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    component: "span"
  }, ` (${(0,_utils_text__WEBPACK_IMPORTED_MODULE_11__/* .toTitleCase */ .L)(
    encounter.status
  )})`))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_elephant_healthcare_mui_button__WEBPACK_IMPORTED_MODULE_0__/* .LinkButton */ .Qj, {
    to: link,
    "data-testid": "patientHistory.anc.details"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    id: "patient.anc.history.card.link",
    defaultMessage: "View details"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_elephant_healthcare_mui_card__WEBPACK_IMPORTED_MODULE_1__/* .CardDetails */ .u0, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    mb: 4
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    container: true
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    variant: "body2",
    color: "textSecondary"
  }, (createdBy == null ? void 0 : createdBy.person) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    id: "patient.anc.history.card.startedBy",
    defaultMessage: "Started by: {name}",
    values: {
      name: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        component: "span",
        variant: "body2",
        color: "textPrimary"
      }, `${(_b = createdBy == null ? void 0 : createdBy.person) == null ? void 0 : _b.firstname} ${(_c = createdBy == null ? void 0 : createdBy.person) == null ? void 0 : _c.lastname}`)
    }
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    variant: "body2",
    color: "textSecondary"
  }, clinic && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    id: "patient.anc.history.card.clinic",
    defaultMessage: "Clinic: {name}",
    values: {
      name: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        component: "span",
        variant: "body2",
        color: "textPrimary"
      }, clinic == null ? void 0 : clinic.name)
    }
  }))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    container: true
  }, sections.flatMap(
    ([name, items]) => items.map(({ field, status }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(AncEncouterResultField, {
      key: `${encounter.id}-${name}-${field}`,
      field,
      status
    }))
  ))))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AncEncounterCard);


/***/ }),

/***/ 10080:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U$": () => (/* binding */ AncEncounterProvider),
  "g8": () => (/* binding */ useAncEncounterContext),
  "IS": () => (/* binding */ useLinkToExistingAntenatalCarePatient)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@6.15.0_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-router-dom/dist/index.js
var dist = __webpack_require__(58311);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var react_router_dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./src/client/clinical-engine/anc-encounter/__generated__/graphql.gql.ts
var graphql_gql = __webpack_require__(3152);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/antenatal-care/__generated__/AncEncounterContext.gql.ts



const defaultOptions = {};
const CreateAncEncounterContextDocument = lib/* gql */.Ps`
    mutation CreateAncEncounterContext($input: CreateAncEncounterInput!) {
  createAncEncounter(input: $input) {
    ...AncEncounterFragment
  }
}
    ${graphql_gql/* AncEncounterFragmentFragmentDoc */.N}`;
function useCreateAncEncounterContextMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(CreateAncEncounterContextDocument, options);
}
const AncEncounterContextDocument = lib/* gql */.Ps`
    query AncEncounterContext($input: QueryAncEncounterInput!) {
  ancEncounter(input: $input) {
    ...AncEncounterFragment
  }
}
    ${graphql_gql/* AncEncounterFragmentFragmentDoc */.N}`;
function useAncEncounterContextQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(AncEncounterContextDocument, options);
}
function useAncEncounterContextLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(AncEncounterContextDocument, options);
}

// EXTERNAL MODULE: ./src/client/common/PatientProvider.ts
var PatientProvider = __webpack_require__(51971);
// EXTERNAL MODULE: ./src/client/antenatal-care/links.ts
var links = __webpack_require__(11819);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-loading-layout@0.4.0_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-loading-layout/dist/module.js
var dist_module = __webpack_require__(69638);
;// CONCATENATED MODULE: ./src/client/antenatal-care/AncEncounterContext.tsx







lib/* gql */.Ps`
  mutation CreateAncEncounterContext($input: CreateAncEncounterInput!) {
    createAncEncounter(input: $input) {
      ...AncEncounterFragment
    }
  }
`;
lib/* gql */.Ps`
  query AncEncounterContext($input: QueryAncEncounterInput!) {
    ancEncounter(input: $input) {
      ...AncEncounterFragment
    }
  }
`;
function useLinkToExistingAntenatalCarePatient() {
  const [searchParams] = (0,dist/* useSearchParams */.lr)();
  return react.useCallback(
    (encounterId) => `${(0,links/* linkToPatientANCEncounter */.Z)(encounterId)}?${searchParams}`,
    [searchParams]
  );
}
const AncEncounterContext = react.createContext(null);
const AncEncounterProvider = ({
  children
}) => {
  const { encounterId } = (0,react_router_dist/* useParams */.UO)();
  const navigate = (0,react_router_dist/* useNavigate */.s0)();
  const { uuid } = (0,PatientProvider/* usePatientContext */.p)();
  const getLinkToExistingEncounter = useLinkToExistingAntenatalCarePatient();
  const [createEncounter, { data: createData }] = useCreateAncEncounterContextMutation();
  const { data: queryData } = useAncEncounterContextQuery({
    variables: { input: { id: encounterId } },
    skip: !encounterId
  });
  const createEmptyEncounter = react.useCallback(() => {
    createEncounter({
      variables: { input: { patientUuid: uuid } }
    });
  }, [uuid, createEncounter]);
  react.useEffect(() => {
    if (encounterId)
      return;
    createEmptyEncounter();
  }, [createEmptyEncounter, encounterId]);
  const encounter = react.useMemo(() => {
    var _a, _b;
    if ((queryData || createData) && !encounterId) {
      const { id } = (_a = (queryData == null ? void 0 : queryData.ancEncounter) || (createData == null ? void 0 : createData.createAncEncounter)) != null ? _a : {};
      navigate(`${getLinkToExistingEncounter(id)}`, { replace: true });
    }
    return (_b = (queryData == null ? void 0 : queryData.ancEncounter) || (createData == null ? void 0 : createData.createAncEncounter)) != null ? _b : null;
  }, [
    queryData,
    createData,
    navigate,
    encounterId,
    getLinkToExistingEncounter
  ]);
  if (!encounter) {
    return /* @__PURE__ */ react.createElement(dist_module/* default */.Z, null);
  }
  return /* @__PURE__ */ react.createElement(AncEncounterContext.Provider, {
    value: encounter
  }, children);
};
const useAncEncounterContext = () => {
  const context = react.useContext(AncEncounterContext);
  if (context === void 0) {
    throw new Error(
      "useAncEncounter must be used within a AncEncounterProvider"
    );
  }
  return context;
};


/***/ }),

/***/ 47871:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": () => (/* binding */ AntenatalCarePage)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/common/PatientProvider.ts
var PatientProvider = __webpack_require__(51971);
// EXTERNAL MODULE: ./src/client/components/HTMLControls/index.js + 10 modules
var HTMLControls = __webpack_require__(95803);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/index.tsx
var PatientOverview = __webpack_require__(9559);
// EXTERNAL MODULE: ./src/client/components/DynamicBreadcrumbs/DynamicBreadcrumbs.tsx
var DynamicBreadcrumbs = __webpack_require__(63592);
// EXTERNAL MODULE: ./src/client/antenatal-care/AncEncounterContext.tsx + 1 modules
var AncEncounterContext = __webpack_require__(10080);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Tabs/Tabs.js + 2 modules
var Tabs = __webpack_require__(57626);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(76920);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./src/client/antenatal-care/constants.ts
var constants = __webpack_require__(17234);
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./src/client/forms/hookForm/index.ts
var hookForm = __webpack_require__(86347);
// EXTERNAL MODULE: ./src/client/forms/validation/ValidationContext.ts
var ValidationContext = __webpack_require__(35831);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(77572);
;// CONCATENATED MODULE: ./src/client/antenatal-care/Heading.tsx


const HeadingContainer = (0,styled/* default */.Z)("div")(({ theme }) => ({
  "margin-bottom": theme.spacing(4)
}));
const HeadingItems = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(2)
}));
const Heading = ({
  text
}) => {
  return /* @__PURE__ */ react.createElement(HeadingContainer, null, /* @__PURE__ */ react.createElement(HeadingItems, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h3"
  }, text)), /* @__PURE__ */ react.createElement(Divider/* default */.Z, null));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
;// CONCATENATED MODULE: ./src/client/antenatal-care/CounsellingForm.tsx






const CounsellingForm = ({ disabled }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const sections = [
    {
      name: constants/* fields.hiv */.XU.hiv,
      label: formatMessage({
        id: "anc.counselling.form.hiv",
        defaultMessage: "HIV Testing Services"
      })
    },
    {
      name: constants/* fields.femaleGenitalMutilation */.XU.femaleGenitalMutilation,
      label: formatMessage({
        id: "anc.counselling.form.fgm",
        defaultMessage: "Female Genital Mutilation"
      })
    },
    {
      name: constants/* fields.maternalNutrition */.XU.maternalNutrition,
      label: formatMessage({
        id: "anc.counselling.form.maternalNutrition",
        defaultMessage: "Maternal Nutrition"
      })
    },
    {
      name: constants/* fields.breastfeeding */.XU.breastfeeding,
      label: formatMessage({
        id: "anc.counselling.form.breastfeeding",
        defaultMessage: "Early Initiation of Breast Feeding"
      })
    },
    {
      name: constants/* fields.exclusiveBreastfeeding */.XU.exclusiveBreastfeeding,
      label: formatMessage({
        id: "anc.counselling.form.exclusiveBreastfeeding",
        defaultMessage: "Exclusive Breast Feeding"
      })
    }
  ];
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, null, /* @__PURE__ */ react.createElement(Heading, {
    text: formatMessage({
      id: "anc.form.counselling",
      defaultMessage: "Counselling"
    })
  }), sections.map((section) => /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    key: section.name
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFCheckboxField */.lY, {
    name: section.name,
    label: section.label,
    disabled
  }))));
};
/* harmony default export */ const antenatal_care_CounsellingForm = (CounsellingForm);

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(66264);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4548);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/client/antenatal-care/GeneralForm.tsx








const GeneralForm = ({ disabled }) => {
  var _a, _b;
  const { setValue } = (0,index_esm/* useForm */.cI)();
  const { touchedFields } = (0,index_esm/* useFormState */.cl)();
  const lastMenstrualPeriod = (0,index_esm/* useWatch */.qo)({
    name: "ageOfPregnancy.lastMenstrualPeriod"
  });
  const expectedDeliveryDate = (0,index_esm/* useWatch */.qo)({ name: "dates.expectedDeliveryDate" });
  const hasChangedEDD = (_a = touchedFields[constants/* AntenatalFormSections.dates */.oi.dates]) == null ? void 0 : _a[constants/* AntenatalFormFields.deliveryDate */.p5.deliveryDate];
  const hasChangedGestationalAge = (_b = touchedFields[constants/* AntenatalFormSections.ageOfPregnancy */.oi.ageOfPregnancy]) == null ? void 0 : _b[constants/* AntenatalFormFields.gestationalAge */.p5.gestationalAge];
  (0,react.useEffect)(() => {
    const nextDate = dayjs_min_default()(lastMenstrualPeriod).add(280, "day").toDate();
    if (!hasChangedEDD && (nextDate == null ? void 0 : nextDate.getDate()) !== (expectedDeliveryDate == null ? void 0 : expectedDeliveryDate.getDate()) && lastMenstrualPeriod != null) {
      setValue("dates.expectedDeliveryDate", nextDate);
    }
  }, [lastMenstrualPeriod, expectedDeliveryDate, hasChangedEDD, setValue]);
  (0,react.useEffect)(() => {
    if (lastMenstrualPeriod != null && !hasChangedGestationalAge) {
      setValue(
        "ageOfPregnancy.gestationalAge",
        dayjs_min_default()().diff(lastMenstrualPeriod, "week")
      );
    }
  }, [lastMenstrualPeriod, hasChangedGestationalAge, setValue]);
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, null, /* @__PURE__ */ react.createElement(Heading, {
    text: formatMessage({
      id: "anc.form.headings.dates",
      defaultMessage: "Dates"
    })
  }), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 8
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFDatePicker */.C5, {
    fullWidth: true,
    disabled,
    required: true,
    name: constants/* fields.visitDate */.XU.visitDate,
    disableFuture: true,
    label: formatMessage({
      defaultMessage: "Date of Visit",
      id: "anc.form.fields.visitDate"
    })
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFDatePicker */.C5, {
    fullWidth: true,
    disabled,
    required: true,
    disablePast: true,
    name: constants/* fields.deliveryDate */.XU.deliveryDate,
    label: formatMessage({
      defaultMessage: "Expected Date of Delivery",
      id: "anc.form.fields.deliveryDate"
    })
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    fullWidth: true,
    disabled,
    required: true,
    type: "number",
    name: constants/* fields.visitNumber */.XU.visitNumber,
    label: formatMessage({
      defaultMessage: "Visit Number",
      id: "anc.form.fields.visitNumber"
    })
  }))), /* @__PURE__ */ react.createElement(Heading, {
    text: formatMessage({
      id: "anc.form.headings.parity",
      defaultMessage: "Parity"
    })
  }), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 8
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    required: true,
    fullWidth: true,
    disabled,
    type: "number",
    name: constants/* fields.deliveries */.XU.deliveries,
    label: formatMessage({
      defaultMessage: "Deliveries (24+ weeks)",
      id: "anc.form.fields.deliveries"
    })
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    required: true,
    fullWidth: true,
    disabled,
    name: constants/* fields.miscarriages */.XU.miscarriages,
    type: "number",
    label: formatMessage({
      defaultMessage: "Miscarriages (less than 24 weeks)",
      id: "anc.form.fields.miscarriages"
    })
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, null, /* @__PURE__ */ react.createElement(Heading, {
    text: formatMessage({
      id: "anc.form.headings.ageOfPregnancy",
      defaultMessage: "Age of Pregnancy"
    })
  }), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 8
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFDatePicker */.C5, {
    required: true,
    fullWidth: true,
    disabled,
    disableFuture: true,
    name: constants/* fields.lastMenstrualPeriod */.XU.lastMenstrualPeriod,
    label: formatMessage({
      defaultMessage: "Last menstrual period",
      id: "anc.form.fields.lastMenstrualPeriod"
    })
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    required: true,
    fullWidth: true,
    disabled,
    name: constants/* fields.gestationalAge */.XU.gestationalAge,
    InputProps: {
      endAdornment: /* @__PURE__ */ react.createElement(InputAdornment/* default */.Z, {
        position: "end"
      }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "anc.form.fields.ageOfPregnancy.adornment",
        defaultMessage: "weeks"
      }))
    },
    label: formatMessage({
      defaultMessage: "Age of Pregnancy",
      id: "anc.form.fields.ageOfPregnancy"
    })
  }))))));
};
/* harmony default export */ const antenatal_care_GeneralForm = (GeneralForm);

// EXTERNAL MODULE: ./src/client/clinical-engine/investigationActivities/useCreateInvestigationActivities.tsx + 1 modules
var useCreateInvestigationActivities = __webpack_require__(6246);
// EXTERNAL MODULE: ./src/client/investigations/newInvestigations/InvestigationSelectField.tsx + 3 modules
var InvestigationSelectField = __webpack_require__(22129);
// EXTERNAL MODULE: ./src/client/clinical-engine/investigationActivities/__generated__/useInvestigationActivities.gql.ts
var useInvestigationActivities_gql = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./src/client/investigations/InvestigationActivityOutcome.tsx + 1 modules
var InvestigationActivityOutcome = __webpack_require__(60831);
;// CONCATENATED MODULE: ./src/client/antenatal-care/InvestigationForm/Section.tsx










const translations = {
  [base_gql/* AncInvestigationOutcome.Negative */.n1.Negative]: (0,lib/* defineMessage */.Em)({
    id: "anc.investigations.negative",
    defaultMessage: "Negative"
  }),
  [base_gql/* AncInvestigationOutcome.Positive */.n1.Positive]: (0,lib/* defineMessage */.Em)({
    id: "anc.investigations.positive",
    defaultMessage: "Positive"
  }),
  [base_gql/* AncInvestigationOutcome.Treated */.n1.Treated]: (0,lib/* defineMessage */.Em)({
    id: "anc.investigations.treated",
    defaultMessage: "Treated"
  }),
  [base_gql/* AncInvestigationOutcome.Referred */.n1.Referred]: (0,lib/* defineMessage */.Em)({
    id: "anc.investigations.referred",
    defaultMessage: "Referred"
  })
};
const buildFormInputName = (fieldName) => `investigations.${fieldName}`;
const InvestigationFormSection = ({
  checkOptions,
  handleRequestInvestigation,
  heading,
  info,
  investigationCodes,
  fieldName,
  patientUuid,
  disabled = false
}) => {
  const name = buildFormInputName(fieldName);
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { data } = (0,useInvestigationActivities_gql/* useActiveInvestigationActivitiesQuery */.bT)({
    fetchPolicy: "cache-first"
  });
  const encounter = (0,AncEncounterContext/* useAncEncounterContext */.g8)();
  const investigationsRelatedToSection = react.useMemo(() => {
    var _a, _b;
    return (_b = (_a = data.catalogueInvestigationActivities) == null ? void 0 : _a.filter(
      (i) => {
        var _a2, _b2;
        return investigationCodes.includes((_a2 = i.coding.loinc) == null ? void 0 : _a2.code) || investigationCodes.includes((_b2 = i.coding.elephant) == null ? void 0 : _b2.code);
      }
    )) != null ? _b : [];
  }, [investigationCodes, data]);
  const encounterInvestigations = react.useMemo(
    () => {
      var _a;
      return (_a = encounter == null ? void 0 : encounter.investigations) != null ? _a : [];
    },
    [encounter]
  );
  const sectionInvestigations = react.useMemo(() => {
    var _a;
    return (_a = encounterInvestigations == null ? void 0 : encounterInvestigations.filter(
      (i) => {
        var _a2, _b;
        return investigationCodes.includes((_a2 = i.catalogueItem.coding.loinc) == null ? void 0 : _a2.code) || investigationCodes.includes((_b = i.catalogueItem.coding.elephant) == null ? void 0 : _b.code);
      }
    )) != null ? _a : [];
  }, [investigationCodes, encounterInvestigations]);
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    key: name
  }, /* @__PURE__ */ react.createElement(Heading, {
    text: heading
  }), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 1
  }, (checkOptions == null ? void 0 : checkOptions.length) || (investigationsRelatedToSection == null ? void 0 : investigationsRelatedToSection.length) ? /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    direction: "row"
  }, (checkOptions == null ? void 0 : checkOptions.length) ? /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    style: { marginTop: "-8px" }
  }, checkOptions.map((option) => {
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      sx: { mx: 1 },
      key: option
    }, /* @__PURE__ */ react.createElement(hookForm/* RHFCheckboxField */.lY, {
      name: `${name}.${option}`,
      label: formatMessage(translations[option]),
      hideHelper: true,
      disabled,
      dataTestId: `anc.${name}.${option}`
    }));
  })) : null, (investigationsRelatedToSection == null ? void 0 : investigationsRelatedToSection.length) ? /* @__PURE__ */ react.createElement(react.Fragment, null, (checkOptions == null ? void 0 : checkOptions.length) ? /* @__PURE__ */ react.createElement(Divider/* default */.Z, {
    orientation: "vertical",
    style: { margin: "auto 16px", height: "5rem" }
  }) : null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, investigationsRelatedToSection.map((investigation) => {
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      sx: { mx: 1 },
      key: investigation.id
    }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
      color: "secondary",
      onClick: () => handleRequestInvestigation(investigation),
      disabled,
      "data-testid": `anc.investigation.quickAddButton.${investigation.title}`
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "anc.form.investigations.addBtn",
      defaultMessage: "Add {investigation}",
      values: { investigation: investigation.title }
    })));
  })))) : null) : null, (sectionInvestigations == null ? void 0 : sectionInvestigations.length) ? /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mb: 3
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    sx: { m: 4 }
  }, sectionInvestigations.map((investigation) => {
    return /* @__PURE__ */ react.createElement(InvestigationActivityOutcome/* default */.Z, {
      key: investigation._id,
      defaultExpanded: false,
      investigation,
      subtitle: formatMessage({
        id: "investigationActivity.outcome.header",
        defaultMessage: "Investigation"
      }),
      patientUuid
    });
  })))) : null, info ? /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 11
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextArea */.r, {
    name: `${fieldName}.info`,
    disabled
  })) : null));
};
/* harmony default export */ const Section = (InvestigationFormSection);

;// CONCATENATED MODULE: ./src/client/antenatal-care/InvestigationForm/index.tsx












const sectionConfigurations = {
  [constants/* AntenatalFormFields.syphillis */.p5.syphillis]: {
    checks: [
      base_gql/* AncInvestigationOutcome.Negative */.n1.Negative,
      base_gql/* AncInvestigationOutcome.Positive */.n1.Positive,
      base_gql/* AncInvestigationOutcome.Treated */.n1.Treated
    ],
    investigationCodes: ["8041-6", "5292-8"]
  },
  [constants/* AntenatalFormFields.hepatitisB */.p5.hepatitisB]: {
    checks: [
      base_gql/* AncInvestigationOutcome.Negative */.n1.Negative,
      base_gql/* AncInvestigationOutcome.Positive */.n1.Positive,
      base_gql/* AncInvestigationOutcome.Referred */.n1.Referred
    ],
    investigationCodes: ["95235-8"]
  },
  [constants/* AntenatalFormFields.hepatitisC */.p5.hepatitisC]: {
    checks: [
      base_gql/* AncInvestigationOutcome.Negative */.n1.Negative,
      base_gql/* AncInvestigationOutcome.Positive */.n1.Positive,
      base_gql/* AncInvestigationOutcome.Referred */.n1.Referred
    ],
    investigationCodes: ["95237-4"]
  },
  [constants/* AntenatalFormFields.vitals */.p5.vitals]: {
    checks: [],
    investigationCodes: ["85353-1"]
  },
  [constants/* AntenatalFormFields.haematology */.p5.haematology]: {
    checks: [],
    investigationCodes: ["30350-3", "20570-8"]
  },
  [constants/* AntenatalFormFields.bloodSugar */.p5.bloodSugar]: {
    checks: [],
    investigationCodes: ["39480-9"]
  },
  [constants/* AntenatalFormFields.urinalysis */.p5.urinalysis]: {
    checks: [],
    investigationCodes: ["24356-8"]
  },
  [constants/* AntenatalFormFields.associatedProblems */.p5.associatedProblems]: {
    checks: [],
    investigationCodes: [],
    info: true
  }
};
const InvestigationsForm = ({ disabled }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const translations = {
    vitals: formatMessage({
      id: "anc.investigations.vitals",
      defaultMessage: "Vitals"
    }),
    syphillis: formatMessage({
      id: "anc.investigations.syphillis",
      defaultMessage: "Syphillis"
    }),
    hepatitisB: formatMessage({
      id: "anc.investigations.hepatitisB",
      defaultMessage: "Hepatitis B"
    }),
    hepatitisC: formatMessage({
      id: "anc.investigations.hepatitisC",
      defaultMessage: "Hepatitis C"
    }),
    haematology: formatMessage({
      id: "anc.investigations.haematology",
      defaultMessage: "Haematology"
    }),
    bloodSugar: formatMessage({
      id: "anc.investigations.bloodSugar",
      defaultMessage: "Blood sugar"
    }),
    urinalysis: formatMessage({
      id: "anc.investigations.urinalysis",
      defaultMessage: "Urinalysis"
    }),
    associatedProblems: formatMessage({
      id: "anc.investigations.associatedProblems",
      defaultMessage: "Associated problems"
    })
  };
  const encounter = (0,AncEncounterContext/* useAncEncounterContext */.g8)();
  const { id: encounterId } = encounter;
  const sectionInvestigationCodes = react.useMemo(
    () => Object.values(sectionConfigurations).flatMap(
      ({ investigationCodes }) => investigationCodes
    ),
    []
  );
  const genericEncounterInvestigations = react.useMemo(() => {
    var _a, _b;
    return (_b = (_a = encounter.investigations) == null ? void 0 : _a.filter(
      (i) => {
        var _a2, _b2;
        return !sectionInvestigationCodes.includes(
          (_a2 = i.catalogueItem.coding.loinc) == null ? void 0 : _a2.code
        ) && !sectionInvestigationCodes.includes(
          (_b2 = i.catalogueItem.coding.elephant) == null ? void 0 : _b2.code
        );
      }
    )) != null ? _b : [];
  }, [sectionInvestigationCodes, encounter.investigations]);
  const { data } = (0,useInvestigationActivities_gql/* useActiveInvestigationActivitiesQuery */.bT)({
    fetchPolicy: "cache-first"
  });
  const investigationList = data == null ? void 0 : data.catalogueInvestigationActivities;
  const { uuid: patientUuid } = (0,PatientProvider/* usePatientContext */.p)();
  const { createInvestigationActivities, mapItemToInput } = (0,useCreateInvestigationActivities/* default */.Z)();
  const handleRequestInvestigation = react.useCallback(
    async (investigationItem) => {
      const input = [
        mapItemToInput(investigationItem, {
          patientUuid,
          clinicalEvent: {
            id: encounterId,
            type: base_gql/* ClinicalEventType.AncEncounter */.gW.AncEncounter
          }
        })
      ];
      await createInvestigationActivities({ variables: { input } });
    },
    [createInvestigationActivities, encounterId, mapItemToInput, patientUuid]
  );
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    direction: "column",
    spacing: 1
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    my: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(InvestigationSelectField/* default */.Z, {
    investigationList,
    appendInvestigation: handleRequestInvestigation,
    disabled
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, genericEncounterInvestigations.map((investigation) => {
    return /* @__PURE__ */ react.createElement(InvestigationActivityOutcome/* default */.Z, {
      key: investigation._id,
      defaultExpanded: false,
      investigation,
      subtitle: formatMessage({
        id: "investigationActivity.outcome.header",
        defaultMessage: "Investigation"
      }),
      patientUuid
    });
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, Object.keys(sectionConfigurations).map((section) => {
    const sectionConfig = sectionConfigurations[section];
    return /* @__PURE__ */ react.createElement(Section, {
      key: section,
      heading: translations[section],
      fieldName: section,
      info: sectionConfig.info,
      checkOptions: sectionConfig.checks,
      investigationCodes: sectionConfig.investigationCodes,
      handleRequestInvestigation,
      patientUuid,
      disabled
    });
  })));
};
/* harmony default export */ const InvestigationForm = (InvestigationsForm);

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var user_context_provider_dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var graphql_tag_lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./src/client/clinical-engine/anc-encounter/__generated__/graphql.gql.ts
var graphql_gql = __webpack_require__(3152);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/antenatal-care/Prescription/__generated__/OutpatientPrescriptionsForm.gql.ts



const defaultOptions = {};
const CreateOutpatientPrescriptionDocument = graphql_tag_lib/* gql */.Ps`
    mutation CreateOutpatientPrescription($input: CreateOutpatientPrescriptionsInput!) {
  createOutpatientPrescriptions(input: $input) {
    ...EncounterPrescriptionFragment
  }
}
    ${graphql_gql/* EncounterPrescriptionFragmentFragmentDoc */.X}`;
function useCreateOutpatientPrescriptionMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(CreateOutpatientPrescriptionDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-card@0.2.10_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@elephant-healthcare/mui-card/dist/module.js
var mui_card_dist_module = __webpack_require__(21534);
// EXTERNAL MODULE: ./src/client/common/i18n/prescriptions.ts
var prescriptions = __webpack_require__(59028);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/WeightAndAllergies/index.ts + 3 modules
var WeightAndAllergies = __webpack_require__(36134);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/client/components/Consultation/InitialForm/PrescriptionsSection/useDoseUnits.ts
var useDoseUnits = __webpack_require__(68811);
// EXTERNAL MODULE: ./src/client/inpatient/prescribe/components/index.tsx + 11 modules
var components = __webpack_require__(43244);
;// CONCATENATED MODULE: ./src/client/antenatal-care/Prescription/OutpatientPrescriptionInputCard.tsx












const OutpatientPrescriptionInputCard = (props) => {
  const { patientUuid, onDelete: handleDelete, index } = props;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const durationUnits = (0,prescriptions/* useDurationUnits */.K0)({ uppercaseValues: true });
  const units = (0,useDoseUnits/* default */.Z)();
  const prescriptionFieldName = `prescriptions.${index}`;
  const { setValue } = (0,index_esm/* useFormContext */.Gc)();
  function handleChangeHowOftenUnit(_, value) {
    setValue(`${prescriptionFieldName}.rateMeasurement.unit`, value);
    setValue(`${prescriptionFieldName}.frequency.unit`, void 0);
  }
  function handleDeleteClick() {
    handleDelete(index);
  }
  return /* @__PURE__ */ react.createElement(mui_card_dist_module/* Card */.Zb, {
    color: mui_card_dist_module/* CardColors.PRESCRIPTION */.L3.PRESCRIPTION,
    key: index,
    "data-testid": "OutpatientPrescription"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: true
  }, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardTitle */.ll, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.anc.prescription.inputcard.title",
    defaultMessage: "Prescription"
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true
  }, /* @__PURE__ */ react.createElement(dist_module/* IconButton */.hU, {
    "data-testid": `prescription-delete-${index}`,
    color: "alert",
    onClick: handleDeleteClick,
    "aria-label": formatMessage({
      id: "patient.anc.prescription.inputcard.delete",
      defaultMessage: "Remove Prescription"
    })
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.BinIcon, null)))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    pb: 2,
    pl: 1
  }, /* @__PURE__ */ react.createElement(WeightAndAllergies/* WeightAndAllergiesSummary */.H, {
    patientUuid
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(components/* ClinicalProductInput */.wl, {
    name: `${prescriptionFieldName}.clinicalProduct`
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6,
    md: 3
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    name: `${prescriptionFieldName}.doseMeasurement.value`,
    required: true,
    label: formatMessage({
      id: "patient.anc.prescription.inputcard.dose.quantity.label",
      defaultMessage: "Dose"
    }),
    type: "number",
    placeholder: "",
    InputProps: { inputProps: { min: 0, step: 0.01 } }
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6,
    md: 3
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFSelectField */.DM, {
    name: `${prescriptionFieldName}.doseMeasurement.unit`,
    required: true,
    label: formatMessage({
      id: "patient.anc.prescription.inputcard.dose.unit.label",
      defaultMessage: "Unit"
    }),
    options: units,
    "data-testid": `prescription-dose-quantity-unit-${index}`
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6,
    md: 3
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    name: `${prescriptionFieldName}.rateMeasurement.value`,
    required: true,
    label: formatMessage({
      id: "patient.anc.prescription.inputcard.dose.rate.value.label",
      defaultMessage: "How often?"
    }),
    type: "number",
    placeholder: "",
    InputProps: { inputProps: { min: 1 } }
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6,
    md: "auto"
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFRadioField */.ov, {
    name: `${prescriptionFieldName}.rateMeasurement.unit`,
    "data-testid": "prescription-dose-rate-quantity-unit",
    label: formatMessage({
      id: "patient.anc.prescription.inputcard.dose.rate.unit.label",
      defaultMessage: "Per"
    }),
    required: true,
    options: durationUnits,
    onChange: handleChangeHowOftenUnit
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6,
    md: 3
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    name: `${prescriptionFieldName}.frequency.value`,
    required: true,
    label: formatMessage({
      id: "patient.anc.prescription.inputcard.dose.duration.value.label",
      defaultMessage: "How Long?"
    }),
    type: "number",
    placeholder: "",
    InputProps: { inputProps: { min: 1 } }
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 6,
    md: "auto"
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFRadioField */.ov, {
    name: `${prescriptionFieldName}.frequency.unit`,
    "data-testid": "prescription-dose-duration-quantity-unit",
    required: true,
    options: durationUnits
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: "auto"
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFCheckboxField */.lY, {
    name: `${prescriptionFieldName}.asRequired`,
    label: formatMessage({
      id: "patient.anc.prescription.inputcard.dose.asNeeded.label",
      defaultMessage: "As required"
    })
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    name: `${prescriptionFieldName}.note`,
    label: formatMessage({
      id: "patient.anc.prescription.inputcard.note.label",
      defaultMessage: "Additional note"
    }),
    placeholder: "Additional note",
    rows: 4,
    multiline: true
  }))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
;// CONCATENATED MODULE: ./src/client/antenatal-care/Prescription/useValidationSchema.tsx


const useValidationSchema = () => {
  return (0,react.useMemo)(
    () => es.object({
      prescriptions: es.array(
        es.object({
          asRequired: es.boolean(),
          clinicalProduct: es.object({
            id: es.string().required(),
            productType: es.string().oneOf(["vmp", "amp"]).required()
          }).required(),
          note: es.string(),
          doseMeasurement: es.object({
            unit: es.string().required(),
            value: es.number().required()
          }),
          rateMeasurement: es.object({
            unit: es.string().oneOf(["DAY", "WEEK", "MONTH"]).required(),
            value: es.number().required()
          }),
          frequency: es.object({
            unit: es.string().oneOf(["DAY", "WEEK", "MONTH"]).required(),
            value: es.number().required()
          })
        })
      )
    }),
    []
  );
};

// EXTERNAL MODULE: ./src/client/components/Consultation/InitialForm/AddPrescriptionButton.tsx
var AddPrescriptionButton = __webpack_require__(3845);
;// CONCATENATED MODULE: ./src/client/antenatal-care/Prescription/OutpatientPrescriptionsForm.tsx















graphql_tag_lib/* gql */.Ps`
  mutation CreateOutpatientPrescription($input: CreateOutpatientPrescriptionsInput!) {
    createOutpatientPrescriptions(input: $input) {
      ...EncounterPrescriptionFragment
    }
  }
`;
/* harmony default export */ const OutpatientPrescriptionsForm = (({
  patientUuid,
  disabled
}) => {
  const user = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const { id: encounterId } = (0,AncEncounterContext/* useAncEncounterContext */.g8)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const validationSchema = useValidationSchema();
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(validationSchema)
  });
  const {
    fields: prescriptions,
    append: addPrescription,
    remove: removePrescription
  } = (0,index_esm/* useFieldArray */.Dq)({
    control: formMethods.control,
    name: "prescriptions"
  });
  const [mutation] = useCreateOutpatientPrescriptionMutation();
  const handleSubmit = async (formValues) => {
    const input = {
      prescriptions: formValues.prescriptions.map(
        (p) => {
          return {
            asRequired: !!p.asRequired,
            clinicalEventRef: {
              id: encounterId,
              type: base_gql/* ClinicalEventType.AncEncounter */.gW.AncEncounter
            },
            clinicalProductRef: {
              id: p.clinicalProduct.id,
              type: p.clinicalProduct.productType.toUpperCase()
            },
            facilityId: user == null ? void 0 : user.facilityId,
            note: p.note,
            patientId: patientUuid,
            doseMeasurement: p.doseMeasurement,
            rateMeasurement: p.rateMeasurement,
            frequency: p.frequency
          };
        }
      )
    };
    await mutation({
      variables: { input },
      onCompleted: () => {
        formMethods.reset();
      },
      update: (cache, { data }) => {
        cache.updateFragment(
          {
            fragment: graphql_gql/* AncEncounterFragmentFragmentDoc */.N,
            id: `AncEncounter:${encounterId}`,
            fragmentName: "AncEncounterFragment"
          },
          (cacheData) => {
            var _a, _b;
            return {
              ...cacheData,
              prescriptions: [
                ...(_a = cacheData == null ? void 0 : cacheData.prescriptions) != null ? _a : [],
                ...(_b = data == null ? void 0 : data.createOutpatientPrescriptions) != null ? _b : []
              ]
            };
          }
        );
      }
    });
  };
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mt: "2em"
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "anc-outpatient-prescriptions",
    onSubmit: formMethods.handleSubmit(handleSubmit)
  }, prescriptions.map(({ id }, idx) => {
    return /* @__PURE__ */ react.createElement(OutpatientPrescriptionInputCard, {
      key: id,
      index: idx,
      onDelete: () => {
        removePrescription(idx);
      },
      patientUuid
    });
  }), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    textAlign: "right",
    mt: "2em",
    mb: "2em"
  }, /* @__PURE__ */ react.createElement(AddPrescriptionButton/* default */.Z, {
    onClick: () => {
      addPrescription({});
    },
    disabled
  }), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    disabled: !prescriptions.length || formMethods.formState.isSubmitting || disabled,
    type: "button",
    onClick: formMethods.handleSubmit(handleSubmit),
    "data-testid": "outpatient.prescription.prescribeMedicineButton"
  }, formatMessage({
    defaultMessage: "Prescribe Medicine",
    id: "anc.form.prescriptions.prescribeMedicine"
  }))))));
});

// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
// EXTERNAL MODULE: ./src/client/antenatal-care/Prescription/AncPrescriptionCard.tsx
var AncPrescriptionCard = __webpack_require__(22594);
;// CONCATENATED MODULE: ./src/client/antenatal-care/PrescriptionsSection.tsx








/* harmony default export */ const PrescriptionsSection = (({ disabled }) => {
  const { patientUuid } = (0,useQuerystring/* default */.Z)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { prescriptions } = (0,AncEncounterContext/* useAncEncounterContext */.g8)();
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Heading, {
    text: formatMessage({
      id: "anc.form.headings.prescriptions",
      defaultMessage: "Prescriptions"
    }),
    hideNext: true
  }), prescriptions == null ? void 0 : prescriptions.map((p) => {
    return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      mb: "1em"
    }, /* @__PURE__ */ react.createElement(AncPrescriptionCard/* AncPrescriptionCard */.j, {
      prescription: p
    }));
  }), /* @__PURE__ */ react.createElement(OutpatientPrescriptionsForm, {
    patientUuid,
    disabled
  }));
});

;// CONCATENATED MODULE: ./src/client/antenatal-care/TabPanel.tsx

function TabPanel({
  children,
  value,
  activeTab
}) {
  return /* @__PURE__ */ react.createElement("div", {
    role: "tabpanel",
    hidden: value !== activeTab
  }, value === activeTab && children);
}

;// CONCATENATED MODULE: ./src/client/antenatal-care/__generated__/useUpdateAncEncounter.gql.ts



const useUpdateAncEncounter_gql_defaultOptions = {};
const UpdateAncEncounterContextDocument = graphql_tag_lib/* gql */.Ps`
    mutation UpdateAncEncounterContext($input: UpdateAncEncounterInput!) {
  updateAncEncounter(input: $input) {
    ...AncEncounterFragment
  }
}
    ${graphql_gql/* AncEncounterFragmentFragmentDoc */.N}`;
function useUpdateAncEncounterContextMutation(baseOptions) {
  const options = { ...useUpdateAncEncounter_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UpdateAncEncounterContextDocument, options);
}

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/History/__generated__/History.gql.ts
var History_gql = __webpack_require__(98256);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
;// CONCATENATED MODULE: ./src/client/antenatal-care/useUpdateAncEncounter.tsx





graphql_tag_lib/* gql */.Ps`
  mutation UpdateAncEncounterContext($input: UpdateAncEncounterInput!) {
    updateAncEncounter(input: $input) {
      ...AncEncounterFragment
    }
  }
`;
function transformFormInvestigationCheckToGql(formValues) {
  const checked = Object.entries(formValues).map(([key, value]) => {
    if (value === false)
      return null;
    return key;
  }).filter((i) => i !== null);
  return checked;
}
function transformAncFormToGqlInput(data) {
  var _a, _b, _c, _d;
  return {
    ageOfPregnancy: !Number.isNaN(Number(data.ageOfPregnancy.gestationalAge)) && Number(data.ageOfPregnancy.gestationalAge),
    dueDate: (_b = (_a = data.dates.expectedDeliveryDate) == null ? void 0 : _a.toISOString()) != null ? _b : null,
    lastMenstrualPeriod: (_d = (_c = data.ageOfPregnancy.lastMenstrualPeriod) == null ? void 0 : _c.toISOString()) != null ? _d : null,
    parityDeliveries: !Number.isNaN(Number(data.parity.deliveries)) && Number(data.parity.deliveries),
    parityMiscarriages: !Number.isNaN(Number(data.parity.miscarriages)) && Number(data.parity.miscarriages),
    visitNumber: !Number.isNaN(Number(data.dates.visitNumber)) && Number(data.dates.visitNumber),
    earlyInitiationOfBreastfeeding: data.counselling.breastfeeding,
    exclusiveBreastfeeding: data.counselling.exclusiveBreastfeeding,
    femaleGenitalMutilation: data.counselling.femaleGenitalMutilation,
    hivTesting: data.counselling.hiv,
    maternalNutrition: data.counselling.maternalNutrition,
    hepatitisBInvestigation: transformFormInvestigationCheckToGql(
      data.investigations.hepatitisB
    ),
    hepatitisCInvestigation: transformFormInvestigationCheckToGql(
      data.investigations.hepatitisC
    ),
    syphilisInvestigation: transformFormInvestigationCheckToGql(
      data.investigations.syphillis
    ),
    associatedProblems: data.investigations.associatedProblems.info
  };
}
const useUpdateAncEncounter = ({
  encounterId
}) => {
  const [updateAncEncounter, { loading, error }] = useUpdateAncEncounterContextMutation();
  const searchWholeTerritory = (0,featureFlags/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const doUpdateAncEncounter = react.useCallback(
    async (data, status) => {
      const input = {
        id: encounterId,
        ...transformAncFormToGqlInput(data),
        status
      };
      await updateAncEncounter({
        variables: {
          input
        },
        update: (cache, res) => {
          cache.updateQuery(
            {
              query: History_gql/* AncEncountersDocument */.Gq,
              variables: {
                input: {
                  params: {
                    patientId: res.data.updateAncEncounter.patient.uuid,
                    searchWholeTerritory
                  }
                }
              }
            },
            (cached) => {
              const position = cached.ancEncounters.encounters.findIndex(
                (e) => e.id === encounterId
              );
              const encounters = [...cached.ancEncounters.encounters];
              if (position !== -1) {
                encounters[position] = res.data.updateAncEncounter;
              } else {
                encounters.push(res.data.updateAncEncounter);
              }
              return {
                ...cached,
                ancEncounters: { ...cached.ancEncounters, encounters }
              };
            }
          );
        }
      });
    },
    [encounterId, searchWholeTerritory, updateAncEncounter]
  );
  return { updateAncEncounter: doUpdateAncEncounter, loading, error };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./src/client/patient/links.ts
var links = __webpack_require__(90806);
// EXTERNAL MODULE: ./src/ui/Modal/index.ts + 3 modules
var Modal = __webpack_require__(59564);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
;// CONCATENATED MODULE: ./src/client/antenatal-care/CompleteAncEncounterModal.tsx







const WarningMessage = (0,styled/* default */.Z)(Typography/* default */.Z)(({ theme }) => ({
  color: theme.palette.warning.main,
  fontWeight: "bold"
}));
const CompleteAncEncounterModal = ({
  open,
  onFinish,
  onCancel
}) => {
  return /* @__PURE__ */ react.createElement(Modal/* Modal */.u_, {
    open
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.WarningIcon, {
    style: {
      marginRight: "1em",
      width: 32,
      height: 32
    },
    color: "secondary",
    viewBox: "0 0 32 32"
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.completeModal.completedTitle",
    defaultMessage: "Finish the visit?"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.completeModal.completedBody",
    defaultMessage: "The data will be recorded and sent to the hospital register."
  })), /* @__PURE__ */ react.createElement(WarningMessage, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.completeModal.completedWarning",
    defaultMessage: "You will not be able to edit the data after this."
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: onCancel
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.completeModal.cancel",
    defaultMessage: "Go back"
  })), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    onClick: onFinish,
    "data-testid": "anc.form.completeModal.submitBtn"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.completeModal.submitBtn",
    defaultMessage: "Finish"
  })))));
};
/* harmony default export */ const antenatal_care_CompleteAncEncounterModal = (CompleteAncEncounterModal);

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/esm/Save.js
var Save = __webpack_require__(71246);
;// CONCATENATED MODULE: ./src/client/antenatal-care/SaveChangesAncEncounterModal.tsx







const SaveChangesAncEncounterModal = ({
  open,
  onFinish,
  onCancel
}) => {
  return /* @__PURE__ */ react.createElement(Modal/* Modal */.u_, {
    open
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.WarningIcon, {
    style: {
      marginRight: "1em",
      width: 32,
      height: 32
    },
    color: "secondary",
    viewBox: "0 0 32 32"
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.saveModal.saveChangesTitle",
    defaultMessage: "Save the visit for future use?"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.saveModal.saveChangesBody",
    defaultMessage: "The data will be recorded and saved to the visit details. You'll be able to edit this information later"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: onCancel
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.saveModal.cancel",
    defaultMessage: "Go back"
  })), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    onClick: onFinish,
    "data-testid": "anc.form.saveModal.submitBtn"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.saveModal.submitBtn",
    defaultMessage: "Save"
  })))));
};

;// CONCATENATED MODULE: ./src/client/antenatal-care/validation.ts



const validationSchema = (0,es.object)({
  [constants/* AntenatalFormSections.dates */.oi.dates]: (0,es.object)({
    [constants/* AntenatalFormFields.visitDate */.p5.visitDate]: (0,es.date)(),
    [constants/* AntenatalFormFields.deliveryDate */.p5.deliveryDate]: (0,es.date)(),
    [constants/* AntenatalFormFields.visitNumber */.p5.visitNumber]: (0,es.number)().integer().min(1).max(8)
  }),
  [constants/* AntenatalFormSections.parity */.oi.parity]: (0,es.object)({
    [constants/* AntenatalFormFields.deliveries */.p5.deliveries]: (0,es.number)().integer(),
    [constants/* AntenatalFormFields.miscarriages */.p5.miscarriages]: (0,es.number)().integer()
  }),
  [constants/* AntenatalFormSections.ageOfPregnancy */.oi.ageOfPregnancy]: (0,es.object)({
    [constants/* AntenatalFormFields.lastMenstrualPeriod */.p5.lastMenstrualPeriod]: (0,es.date)(),
    [constants/* AntenatalFormFields.gestationalAge */.p5.gestationalAge]: (0,es.number)().integer().positive()
  }),
  [constants/* AntenatalFormSections.investigations */.oi.investigations]: (0,es.object)({
    [constants/* AntenatalFormFields.syphillis */.p5.syphillis]: (0,es.object)({
      [base_gql/* AncInvestigationOutcome.Treated */.n1.Treated]: (0,es.bool)(),
      [base_gql/* AncInvestigationOutcome.Positive */.n1.Positive]: (0,es.bool)(),
      [base_gql/* AncInvestigationOutcome.Negative */.n1.Negative]: (0,es.bool)()
    }).optional(),
    [constants/* AntenatalFormFields.hepatitisB */.p5.hepatitisB]: (0,es.object)({
      [base_gql/* AncInvestigationOutcome.Referred */.n1.Referred]: (0,es.bool)(),
      [base_gql/* AncInvestigationOutcome.Positive */.n1.Positive]: (0,es.bool)(),
      [base_gql/* AncInvestigationOutcome.Negative */.n1.Negative]: (0,es.bool)()
    }),
    [constants/* AntenatalFormFields.hepatitisC */.p5.hepatitisC]: (0,es.object)({
      [base_gql/* AncInvestigationOutcome.Referred */.n1.Referred]: (0,es.bool)(),
      [base_gql/* AncInvestigationOutcome.Positive */.n1.Positive]: (0,es.bool)(),
      [base_gql/* AncInvestigationOutcome.Negative */.n1.Negative]: (0,es.bool)()
    }),
    [constants/* AntenatalFormFields.associatedProblems */.p5.associatedProblems]: (0,es.object)({
      info: (0,es.string)().optional()
    })
  }),
  [constants/* AntenatalFormSections.counselling */.oi.counselling]: (0,es.object)({
    [constants/* AntenatalFormFields.hiv */.p5.hiv]: (0,es.bool)(),
    [constants/* AntenatalFormFields.breastfeeding */.p5.breastfeeding]: (0,es.bool)(),
    [constants/* AntenatalFormFields.exclusiveBreastfeeding */.p5.exclusiveBreastfeeding]: (0,es.bool)(),
    [constants/* AntenatalFormFields.maternalNutrition */.p5.maternalNutrition]: (0,es.bool)(),
    [constants/* AntenatalFormFields.femaleGenitalMutilation */.p5.femaleGenitalMutilation]: (0,es.bool)()
  })
});

;// CONCATENATED MODULE: ./src/client/antenatal-care/AntenatalCareForm.tsx























const CurrentTab = ({
  activeTab,
  disabled
}) => {
  switch (activeTab) {
    case constants/* AntenatalCareTabs.investigations */.R5.investigations:
      return /* @__PURE__ */ react.createElement(InvestigationForm, {
        disabled
      });
    case constants/* AntenatalCareTabs.prescriptions */.R5.prescriptions:
      return /* @__PURE__ */ react.createElement(TabPanel, {
        value: constants/* AntenatalCareTabs.prescriptions */.R5.prescriptions,
        activeTab
      }, /* @__PURE__ */ react.createElement(PrescriptionsSection, {
        disabled
      }));
    case constants/* AntenatalCareTabs.counselling */.R5.counselling:
      return /* @__PURE__ */ react.createElement(TabPanel, {
        value: constants/* AntenatalCareTabs.counselling */.R5.counselling,
        activeTab
      }, /* @__PURE__ */ react.createElement(antenatal_care_CounsellingForm, {
        disabled
      }));
    default:
      return /* @__PURE__ */ react.createElement(TabPanel, {
        value: constants/* AntenatalCareTabs.general */.R5.general,
        activeTab
      }, /* @__PURE__ */ react.createElement(antenatal_care_GeneralForm, {
        disabled
      }));
  }
};
const getDate = (date) => (date == null ? void 0 : date.length) ? new Date(date) : null;
const getDefaultValues = (encounter) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const syphillis = encounter.syphilisInvestigation;
  const hepatitisB = encounter.hepatitisBInvestigation;
  const hepatitisC = encounter.hepatitisCInvestigation;
  return {
    [constants/* AntenatalFormSections.dates */.oi.dates]: {
      [constants/* AntenatalFormFields.visitDate */.p5.visitDate]: (_a = getDate(encounter.createdAt)) != null ? _a : new Date(),
      [constants/* AntenatalFormFields.deliveryDate */.p5.deliveryDate]: getDate(encounter.dueDate),
      [constants/* AntenatalFormFields.visitNumber */.p5.visitNumber]: (_b = encounter.visitNumber) != null ? _b : 1
    },
    [constants/* AntenatalFormSections.parity */.oi.parity]: {
      [constants/* AntenatalFormFields.deliveries */.p5.deliveries]: encounter.parityDeliveries,
      [constants/* AntenatalFormFields.miscarriages */.p5.miscarriages]: encounter.parityMiscarriages
    },
    [constants/* AntenatalFormSections.ageOfPregnancy */.oi.ageOfPregnancy]: {
      [constants/* AntenatalFormFields.lastMenstrualPeriod */.p5.lastMenstrualPeriod]: getDate(
        encounter.lastMenstrualPeriod
      ),
      [constants/* AntenatalFormFields.gestationalAge */.p5.gestationalAge]: encounter.ageOfPregnancy
    },
    [constants/* AntenatalFormSections.investigations */.oi.investigations]: {
      [constants/* AntenatalFormFields.syphillis */.p5.syphillis]: {
        [base_gql/* AncInvestigationOutcome.Positive */.n1.Positive]: syphillis.includes(
          base_gql/* AncInvestigationOutcome.Positive */.n1.Positive
        ),
        [base_gql/* AncInvestigationOutcome.Negative */.n1.Negative]: syphillis.includes(
          base_gql/* AncInvestigationOutcome.Negative */.n1.Negative
        ),
        [base_gql/* AncInvestigationOutcome.Treated */.n1.Treated]: syphillis.includes(
          base_gql/* AncInvestigationOutcome.Treated */.n1.Treated
        )
      },
      [constants/* AntenatalFormFields.hepatitisB */.p5.hepatitisB]: {
        [base_gql/* AncInvestigationOutcome.Positive */.n1.Positive]: hepatitisB.includes(
          base_gql/* AncInvestigationOutcome.Positive */.n1.Positive
        ),
        [base_gql/* AncInvestigationOutcome.Negative */.n1.Negative]: hepatitisB.includes(
          base_gql/* AncInvestigationOutcome.Negative */.n1.Negative
        ),
        [base_gql/* AncInvestigationOutcome.Referred */.n1.Referred]: hepatitisB.includes(
          base_gql/* AncInvestigationOutcome.Treated */.n1.Treated
        )
      },
      [constants/* AntenatalFormFields.hepatitisC */.p5.hepatitisC]: {
        [base_gql/* AncInvestigationOutcome.Positive */.n1.Positive]: hepatitisC.includes(
          base_gql/* AncInvestigationOutcome.Positive */.n1.Positive
        ),
        [base_gql/* AncInvestigationOutcome.Negative */.n1.Negative]: hepatitisC.includes(
          base_gql/* AncInvestigationOutcome.Negative */.n1.Negative
        ),
        [base_gql/* AncInvestigationOutcome.Referred */.n1.Referred]: hepatitisC.includes(
          base_gql/* AncInvestigationOutcome.Treated */.n1.Treated
        )
      },
      [constants/* AntenatalFormFields.associatedProblems */.p5.associatedProblems]: {
        info: (_c = encounter.associatedProblems) != null ? _c : ""
      }
    },
    [constants/* AntenatalFormSections.counselling */.oi.counselling]: {
      [constants/* AntenatalFormFields.femaleGenitalMutilation */.p5.femaleGenitalMutilation]: (_d = encounter.femaleGenitalMutilation) != null ? _d : false,
      [constants/* AntenatalFormFields.hiv */.p5.hiv]: (_e = encounter.hivTesting) != null ? _e : false,
      [constants/* AntenatalFormFields.exclusiveBreastfeeding */.p5.exclusiveBreastfeeding]: (_f = encounter.exclusiveBreastfeeding) != null ? _f : false,
      [constants/* AntenatalFormFields.breastfeeding */.p5.breastfeeding]: (_g = encounter.earlyInitiationOfBreastfeeding) != null ? _g : false,
      [constants/* AntenatalFormFields.maternalNutrition */.p5.maternalNutrition]: (_h = encounter.maternalNutrition) != null ? _h : false
    }
  };
};
const AntenatalCareForm = ({
  tab,
  isFinished,
  goToNextTab
}) => {
  const encounter = (0,AncEncounterContext/* useAncEncounterContext */.g8)();
  const userContext = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const readonly = userContext.userId !== encounter.createdBy._id || encounter.status !== base_gql/* AncEncounterStatus.InProgress */.Ze.InProgress;
  const navigate = (0,dist/* useNavigate */.s0)();
  const [completionModalOpen, setCompletionModalOpen] = (0,react.useState)(false);
  const [saveChangesModalOpen, setSaveChangesModalOpen] = (0,react.useState)(false);
  const defaultValues = getDefaultValues(encounter);
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    reValidateMode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(validationSchema),
    defaultValues
  });
  const { handleSubmit } = formMethods;
  const { updateAncEncounter } = useUpdateAncEncounter({
    encounterId: encounter.id
  });
  const doUpdate = async (values, status, openModal) => {
    if (readonly) {
      return;
    }
    await updateAncEncounter(values, status);
    navigate((0,links/* linkToPatientDetails */.V)({ patientUuid: encounter.patient.uuid }));
    openModal(false);
  };
  const submit = (status, openModal, submitOnInvalid) => handleSubmit(
    async (formValues) => {
      doUpdate(formValues, status, openModal);
    },
    async () => {
      if (submitOnInvalid) {
        doUpdate(formMethods.getValues(), status, openModal);
      }
    }
  );
  const completeEncounter = submit(
    base_gql/* AncEncounterStatus.Completed */.Ze.Completed,
    setCompletionModalOpen,
    false
  );
  const saveEncounter = submit(
    base_gql/* AncEncounterStatus.InProgress */.Ze.InProgress,
    setSaveChangesModalOpen,
    true
  );
  return /* @__PURE__ */ react.createElement(ValidationContext/* default.Provider */.Z.Provider, {
    value: { validationSchema: validationSchema }
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    onSubmit: (e) => {
      e.preventDefault();
      if (!isFinished) {
        goToNextTab();
      } else {
        if (readonly) {
          return;
        }
        setCompletionModalOpen(true);
      }
    }
  }, /* @__PURE__ */ react.createElement(antenatal_care_CompleteAncEncounterModal, {
    open: completionModalOpen,
    onCancel: () => setCompletionModalOpen(false),
    onFinish: completeEncounter
  }), /* @__PURE__ */ react.createElement(SaveChangesAncEncounterModal, {
    open: saveChangesModalOpen,
    onCancel: () => setSaveChangesModalOpen(false),
    onFinish: saveEncounter
  }), /* @__PURE__ */ react.createElement(CurrentTab, {
    activeTab: tab,
    disabled: readonly
  }), !readonly && /* @__PURE__ */ react.createElement("div", {
    style: { marginBottom: "2em" }
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    startIcon: /* @__PURE__ */ react.createElement(Save/* default */.Z, null),
    style: { marginRight: "1em" },
    color: "secondary",
    onClick: () => {
      setSaveChangesModalOpen(true);
    },
    "data-testid": "anc.form.savebutton"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.saveButton",
    defaultMessage: "Save"
  })), /* @__PURE__ */ react.createElement(hookForm/* RHFSubmitButton */.Qz, {
    disabled: readonly || formMethods.formState.isSubmitting || !formMethods.formState.isValid && isFinished,
    "data-testid": "anc.form.submitButton"
  }, isFinished ? /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.submitButton",
    defaultMessage: "Submit"
  }) : /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "anc.form.nextButton",
    defaultMessage: "Next"
  }))))));
};

;// CONCATENATED MODULE: ./src/client/antenatal-care/AntenatalCarePageContent.tsx







const completedStatuses = [
  base_gql/* AncEncounterStatus.Completed */.Ze.Completed,
  base_gql/* AncEncounterStatus.Cancelled */.Ze.Cancelled,
  base_gql/* AncEncounterStatus.Discontinued */.Ze.Discontinued,
  base_gql/* AncEncounterStatus.EnteredInError */.Ze.EnteredInError
];
const AntenatalCarePageContent = () => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [tab, setTab] = (0,react.useState)(constants/* AntenatalCareTabs.general */.R5.general);
  const [visitedTabs, setVisitedTabs] = (0,react.useState)(
    /* @__PURE__ */ new Set([constants/* AntenatalCareTabs.general */.R5.general])
  );
  const tabs = Object.values(constants/* AntenatalCareTabs */.R5);
  const { status } = (0,AncEncounterContext/* useAncEncounterContext */.g8)();
  const goToNextTab = () => {
    const unvisitedTabs = tabs.filter((t) => !visitedTabs.has(t));
    const nextTab = unvisitedTabs[0] || constants/* AntenatalCareTabs.general */.R5.general;
    setTab(nextTab);
    setVisitedTabs(visitedTabs.add(nextTab));
  };
  (0,react.useEffect)(() => {
    if (!visitedTabs.has(tab)) {
      setVisitedTabs(visitedTabs.add(tab));
    }
  }, [tab, visitedTabs]);
  const isFinished = completedStatuses.includes(status) || visitedTabs.size === tabs.length;
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    sx: { mx: 2 }
  }, /* @__PURE__ */ react.createElement(Tabs/* default */.Z, {
    value: tab,
    onChange: (_, next) => setTab(next)
  }, /* @__PURE__ */ react.createElement(Tab/* default */.Z, {
    value: constants/* AntenatalCareTabs.general */.R5.general,
    label: formatMessage({
      defaultMessage: "GENERAL",
      id: "antenatal.tabs.general"
    })
  }), /* @__PURE__ */ react.createElement(Tab/* default */.Z, {
    value: constants/* AntenatalCareTabs.investigations */.R5.investigations,
    label: formatMessage({
      defaultMessage: "INVESTIGATIONS",
      id: "antenatal.tabs.investigations"
    })
  }), /* @__PURE__ */ react.createElement(Tab/* default */.Z, {
    value: constants/* AntenatalCareTabs.counselling */.R5.counselling,
    label: formatMessage({
      defaultMessage: "COUNSELLING",
      id: "antenatal.tabs.counselling"
    })
  }), /* @__PURE__ */ react.createElement(Tab/* default */.Z, {
    value: constants/* AntenatalCareTabs.prescriptions */.R5.prescriptions,
    label: formatMessage({
      defaultMessage: "PRESCRIPTIONS",
      id: "antenatal.tabs.prescriptions"
    })
  })), /* @__PURE__ */ react.createElement(AntenatalCareForm, {
    tab,
    goToNextTab,
    isFinished
  }));
};

;// CONCATENATED MODULE: ./src/client/antenatal-care/AntenatalCarePage.tsx







const AntenatalCarePage = () => {
  const { uuid: patientUuid } = (0,PatientProvider/* usePatientContext */.p)();
  return /* @__PURE__ */ react.createElement(AncEncounterContext/* AncEncounterProvider */.U$, null, /* @__PURE__ */ react.createElement(DynamicBreadcrumbs/* DynamicBreadcrumbs */.V, null), /* @__PURE__ */ react.createElement(HTMLControls/* PageColumns */.gC, {
    dataTestId: "patientConsultationContainer",
    mainContent: /* @__PURE__ */ react.createElement(AntenatalCarePageContent, null),
    sidebar: /* @__PURE__ */ react.createElement(PatientOverview/* default */.Z, {
      patientUuid
    })
  }));
};


/***/ }),

/***/ 22594:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": () => (/* binding */ AncPrescriptionCard)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _generated_base_gql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3047);
/* harmony import */ var _components_Prescriptions_PrescriptionCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41635);
/* harmony import */ var _utils_prescriptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61267);




const getDispenseStatus = (status) => {
  switch (status) {
    case _generated_base_gql__WEBPACK_IMPORTED_MODULE_1__/* .PrescriptionStatus.Active */ .$g.Active:
      return _utils_prescriptions__WEBPACK_IMPORTED_MODULE_3__/* .PRESCRIPTION_STATES.AWAITING_DISPENSE */ .G.AWAITING_DISPENSE;
    case _generated_base_gql__WEBPACK_IMPORTED_MODULE_1__/* .PrescriptionStatus.Cancelled */ .$g.Cancelled:
      return _utils_prescriptions__WEBPACK_IMPORTED_MODULE_3__/* .PRESCRIPTION_STATES.NA */ .G.NA;
    case _generated_base_gql__WEBPACK_IMPORTED_MODULE_1__/* .PrescriptionStatus.Expired */ .$g.Expired:
      return _utils_prescriptions__WEBPACK_IMPORTED_MODULE_3__/* .PRESCRIPTION_STATES.EXPIRED */ .G.EXPIRED;
    case _generated_base_gql__WEBPACK_IMPORTED_MODULE_1__/* .PrescriptionStatus.Completed */ .$g.Completed:
      return _utils_prescriptions__WEBPACK_IMPORTED_MODULE_3__/* .PRESCRIPTION_STATES.DISPENSED */ .G.DISPENSED;
    default:
      return _utils_prescriptions__WEBPACK_IMPORTED_MODULE_3__/* .PRESCRIPTION_STATES.NA */ .G.NA;
  }
};
const AncPrescriptionCard = ({ prescription }) => {
  var _a;
  const dispensation = prescription.dispensations.items[0];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Prescriptions_PrescriptionCard__WEBPACK_IMPORTED_MODULE_2__/* .PrescriptionCard */ .d, {
    key: prescription.id,
    locationName: "",
    prescribedBy: `${prescription.prescriber.person.firstname} ${prescription.prescriber.person.lastname}`,
    prescribedAt: new Date(prescription.startsAt),
    prescription: {
      uuid: prescription.id,
      note: prescription.note,
      clinician: prescription.prescriber,
      codification: prescription.clinicalProduct.title,
      dose: {
        asNeeded: prescription.asRequired,
        doseQuantity: prescription.dosage,
        rateQuantity: prescription.rate,
        durationQuantity: prescription.frequency
      },
      dispensation: {
        validityPeriod: prescription.stopsAt,
        status: getDispenseStatus(prescription.status),
        dispensedBy: dispensation == null ? void 0 : dispensation.dispensedByUser,
        whenHandedOver: dispensation == null ? void 0 : dispensation.createdAt,
        quantity: dispensation == null ? void 0 : dispensation.quantity,
        substituteMedication: (dispensation == null ? void 0 : dispensation.alternativeDispensed) && {
          name: (_a = dispensation == null ? void 0 : dispensation.sku) == null ? void 0 : _a.name
        },
        dispensedAtLocation: dispensation == null ? void 0 : dispensation.dispenseLocation
      }
    }
  });
};


/***/ }),

/***/ 17234:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R5": () => (/* binding */ AntenatalCareTabs),
/* harmony export */   "XU": () => (/* binding */ fields),
/* harmony export */   "lR": () => (/* binding */ fieldFormatters),
/* harmony export */   "oi": () => (/* binding */ AntenatalFormSections),
/* harmony export */   "p5": () => (/* binding */ AntenatalFormFields)
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11313);
/* harmony import */ var _utils_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55806);


var AntenatalFormSections = /* @__PURE__ */ ((AntenatalFormSections2) => {
  AntenatalFormSections2["generalInfo"] = "generalInfo";
  AntenatalFormSections2["parity"] = "parity";
  AntenatalFormSections2["dates"] = "dates";
  AntenatalFormSections2["ageOfPregnancy"] = "ageOfPregnancy";
  AntenatalFormSections2["investigations"] = "investigations";
  AntenatalFormSections2["counselling"] = "counselling";
  return AntenatalFormSections2;
})(AntenatalFormSections || {});
var AntenatalCareTabs = /* @__PURE__ */ ((AntenatalCareTabs2) => {
  AntenatalCareTabs2["general"] = "general";
  AntenatalCareTabs2["investigations"] = "investigations";
  AntenatalCareTabs2["counselling"] = "counselling";
  AntenatalCareTabs2["prescriptions"] = "prescriptions";
  return AntenatalCareTabs2;
})(AntenatalCareTabs || {});
var AntenatalFormFields = /* @__PURE__ */ ((AntenatalFormFields2) => {
  AntenatalFormFields2["visitDate"] = "visitDate";
  AntenatalFormFields2["deliveryDate"] = "expectedDeliveryDate";
  AntenatalFormFields2["deliveries"] = "deliveries";
  AntenatalFormFields2["miscarriages"] = "miscarriages";
  AntenatalFormFields2["lastMenstrualPeriod"] = "lastMenstrualPeriod";
  AntenatalFormFields2["gestationalAge"] = "gestationalAge";
  AntenatalFormFields2["visitNumber"] = "visitNumber";
  AntenatalFormFields2["vitals"] = "vitals";
  AntenatalFormFields2["syphillis"] = "syphillis";
  AntenatalFormFields2["hepatitisB"] = "hepatitisB";
  AntenatalFormFields2["hepatitisC"] = "hepatitisC";
  AntenatalFormFields2["haematology"] = "haematology";
  AntenatalFormFields2["bloodSugar"] = "bloodSugar";
  AntenatalFormFields2["urinalysis"] = "urinalysis";
  AntenatalFormFields2["associatedProblems"] = "associatedProblems";
  AntenatalFormFields2["hiv"] = "hiv";
  AntenatalFormFields2["maternalNutrition"] = "maternalNutrition";
  AntenatalFormFields2["breastfeeding"] = "breastfeeding";
  AntenatalFormFields2["exclusiveBreastfeeding"] = "exclusiveBreastfeeding";
  AntenatalFormFields2["femaleGenitalMutilation"] = "femaleGenitalMutilation";
  return AntenatalFormFields2;
})(AntenatalFormFields || {});
const fields = {
  gestationalAge: `${"ageOfPregnancy" /* ageOfPregnancy */}.${"gestationalAge" /* gestationalAge */}`,
  lastMenstrualPeriod: `${"ageOfPregnancy" /* ageOfPregnancy */}.${"lastMenstrualPeriod" /* lastMenstrualPeriod */}`,
  deliveryDate: `${"dates" /* dates */}.${"expectedDeliveryDate" /* deliveryDate */}`,
  visitDate: `${"dates" /* dates */}.${"visitDate" /* visitDate */}`,
  visitNumber: `${"dates" /* dates */}.${"visitNumber" /* visitNumber */}`,
  miscarriages: `${"parity" /* parity */}.${"miscarriages" /* miscarriages */}`,
  deliveries: `${"parity" /* parity */}.${"deliveries" /* deliveries */}`,
  vitals: `${"investigations" /* investigations */}.${"vitals" /* vitals */}`,
  syphillis: `${"investigations" /* investigations */}.${"syphillis" /* syphillis */}`,
  hepatitisB: `${"investigations" /* investigations */}.${"hepatitisB" /* hepatitisB */}`,
  hepatitisC: `${"investigations" /* investigations */}.${"hepatitisC" /* hepatitisC */}`,
  haematology: `${"investigations" /* investigations */}.${"haematology" /* haematology */}`,
  bloodSugar: `${"investigations" /* investigations */}.${"bloodSugar" /* bloodSugar */}`,
  urinalysis: `${"investigations" /* investigations */}.${"urinalysis" /* urinalysis */}`,
  associatedProblems: `${"investigations" /* investigations */}.${"associatedProblems" /* associatedProblems */}`,
  hiv: `${"counselling" /* counselling */}.${"hiv" /* hiv */}`,
  maternalNutrition: `${"counselling" /* counselling */}.${"maternalNutrition" /* maternalNutrition */}`,
  breastfeeding: `${"counselling" /* counselling */}.${"breastfeeding" /* breastfeeding */}`,
  exclusiveBreastfeeding: `${"counselling" /* counselling */}.${"exclusiveBreastfeeding" /* exclusiveBreastfeeding */}`,
  femaleGenitalMutilation: `${"counselling" /* counselling */}.${"femaleGenitalMutilation" /* femaleGenitalMutilation */}`
};
const fieldFormatters = {
  earlyInitiationOfBreastfeeding: {
    section: "Counselling",
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "Early initiation of breastfeeding",
      id: "anc.card.fields.breastfeeding"
    }),
    format: (value) => value ? "Yes" : "No"
  },
  exclusiveBreastfeeding: {
    section: "Counselling",
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "Exclusive breastfeeding",
      id: "anc.card.fields.excludeBreastfeeding"
    }),
    format: (value) => value ? "Yes" : "No"
  },
  syphilisInvestigation: {
    section: "Investigations",
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "Syphillis",
      id: "anc.card.fields.syphillisInvestigation"
    }),
    format: (value) => (0,_utils_text__WEBPACK_IMPORTED_MODULE_1__/* .toTitleCase */ .L)(value.toString() || "unknown")
  },
  hepatitisBInvestigation: {
    section: "Counselling",
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "Hepatitis B investigation",
      id: "anc.card.fields.hepatitisBInvestigation"
    }),
    format: (value) => (0,_utils_text__WEBPACK_IMPORTED_MODULE_1__/* .toTitleCase */ .L)(value.toString() || "unknown")
  },
  femaleGenitalMutilation: {
    section: "Counselling",
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "Female genital mutilation",
      id: "anc.card.fields.femaleGenitalMutilation"
    }),
    format: (value) => value ? "Yes" : "No"
  },
  hivTesting: {
    section: "Counselling",
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "HIV testing",
      id: "anc.card.fields.hivTesting"
    }),
    format: (value) => (0,_utils_text__WEBPACK_IMPORTED_MODULE_1__/* .toTitleCase */ .L)(value.toString() || "unknown")
  },
  maternalNutrition: {
    section: "Counselling",
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "Maternal nutrition",
      id: "anc.card.fields.maternalNutrition"
    }),
    format: (value) => value ? "Yes" : "No"
  },
  ageOfPregnancy: {
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "Age of pregnancy",
      id: "anc.card.fields.ageOfPregnancy"
    }),
    section: "Parity",
    format: (value) => value ? `${value} weeks` : "Incomplete"
  },
  dueDate: {
    label: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
      defaultMessage: "Due date",
      id: "anc.card.fields.dueDate"
    }),
    section: "Parity",
    format: (value) => !value ? "Unknown" : new Date(value).toLocaleDateString()
  }
};


/***/ }),

/***/ 11819:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ linkToPatientANCEncounter),
/* harmony export */   "g": () => (/* binding */ linkToPatientCreateANC)
/* harmony export */ });
/* harmony import */ var _patient_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90806);

function linkToPatientCreateANC() {
  return `${(0,_patient_links__WEBPACK_IMPORTED_MODULE_0__/* .linkToPatient */ .i)()}/create-anc`;
}
function linkToPatientANC() {
  return `${(0,_patient_links__WEBPACK_IMPORTED_MODULE_0__/* .linkToPatient */ .i)()}/anc`;
}
function linkToPatientANCEncounter(id = ":encounterId") {
  return `${linkToPatientANC()}/${id}`;
}


/***/ })

}]);